import React from 'react';
import { Tooltip } from 'antd';
import { Client } from 'types';

interface StatusBubbleProps extends React.HTMLAttributes<SVGElement> {
  client?: Client | null;
  /** Force bubble to show online even if offline */
  online?: boolean;
}

export const StatusBubble: React.FC<StatusBubbleProps> = ({
  client,
  online,
  ...rest
}) => {
  let Bubble = BubbleIcon.Green;
  let title = 'Online';
  if (!client || !client.sid) {
    if (!online) {
      Bubble = BubbleIcon.Gray;
      title = 'Offline';
    }
  } else if (!client.isPageVisible) {
    Bubble = BubbleIcon.Orange;
    title = 'Away from page';
  }
  return (
    <Tooltip title={title} mouseEnterDelay={0.3}>
      <Bubble {...rest} />
    </Tooltip>
  );
};

interface BubbleIconProps extends React.HTMLAttributes<SVGElement> {
  color?: string;
}

function BubbleIcon({ color = '#48C546', ...rest }: BubbleIconProps) {
  return (
    <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <circle cx={12.5} cy={12.5} r={9.5} fill={color} />
      <circle cx={12.5} cy={12.5} r={10.5} stroke="#fff" strokeWidth={3} />
    </svg>
  );
}

BubbleIcon.Green = (props: React.HTMLAttributes<SVGElement>) => <BubbleIcon {...props} />;
BubbleIcon.Gray = (props: React.HTMLAttributes<SVGElement>) => (
  <BubbleIcon {...props} color="#CCCCCC" />
);
BubbleIcon.Orange = (props: React.HTMLAttributes<SVGElement>) => (
  <BubbleIcon {...props} color="#FF6A00" />
);
